export const noprofileset = `
## How to Fix the "No Profile Set" Error in AndroidAPS

<div style="display: flex; justify-content: center;">
<img src="https://cdn-images-1.medium.com/max/2000/1*fx0ygQ2-mYWAkBvTjHrBgA.png" alt="No Profile Set Error" />
</div>

When updating AndroidAPS, you might encounter the "No Profile Set" error. In most cases, this issue resolves itself after setting and activating your profile. However, if the problem persists, try these solutions:

 1. **Create a new profile** next the existing one with the same values as your current one and activate it.

 2. **Temporarily disable synchronization (hamburger menu => config builder => scroll down to synchronisation => remove checkmarks)**, then reactivate your profile.

 3. **Modify a value in your current profile**, save the change, activate the profile. If successful then revert to the original value and reactivate the profile.

 4. **Import an older backup settings file**, activate a different profile than the one when you had the error. If successful switch back to your preferred profile.

These steps should restore normal functionality. If you need further assistance, ask the [community](https://www.facebook.com/groups/AndroidAPSUsers), [discord](https://discord.gg/4fQUWHZ4Mw) or feel free to visit our website [opensource.clinic](https://opensource.clinic) for support and troubleshooting.

<!-- blog-contact-footer -->
`;
